import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import dayjs from "dayjs";
import "dayjs/locale/tr";
import tr from "date-fns/locale/tr";

import "./styles/global.css";
import "./styles/buttons.scss";
import "./styles/radiobutton.scss";
import "./styles/loading.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import "./assets/scss/app.scss";
import { RecoilRoot } from 'recoil';

import { persistor, store } from "./store/store";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
dayjs.locale("tr");

registerLocale("tr", tr);
setDefaultLocale("tr");

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <RecoilRoot>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <span className="notranslate" translate="no">
            <App />
          </span>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </RecoilRoot>
  // </React.StrictMode>
);

String.prototype.replaceAll = function (search, replacement) {
  var target: any = this;
  return target.split(search).join(replacement);
};

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
